<template>
  <PLink :simple-url="formatedLink" :class="$style.link">
    <div :class="$style.content">
      <Title
        :title-params="content.article_title"
        is-title
        :class="$style.title"
      />
      <RichText :text-params="formatedIntroduction" :class="$style.desc" />
      <div :class="$style.newsInfos">
        <PImage
          v-if="content.small_news_logo.url"
          :image-object="content.small_news_logo"
          :class="$style.newsLogo"
        />
        <p :class="$style.newsName">{{ content.news_name }}</p>
        <p v-if="content.date" :class="$style.date">{{ formatedDate }}</p>
      </div>
    </div>
    <div :class="$style.view">
      <PImage :image-object="content.article_illustration" sizes="xs:500px" />
    </div>
  </PLink>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'
import PLink from '~/components/PLink'
import linkResolver from '~/utils/prismic/link-resolver'

export default {
  name: 'ArticleCard',

  components: {
    Title,
    RichText,
    PLink,
  },

  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    content() {
      return this.article.data
    },

    formatedDate() {
      return `${this.$t('the')} ${this.$d(
        new Date(this.content.date),
        'longDate'
      )}`
    },

    formatedLink() {
      return linkResolver({ ...this.article, link_type: 'Document' })
    },

    formatedIntroduction() {
      return this.content.article_introduction.map((e) => {
        e.text = e.text.split('.')[0] + '.'
        return e
      })
    },
  },
}
</script>

<style lang="scss" module>
.link {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 25px;
  border-radius: 8px;

  text-decoration: none;

  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: 3px 3px 10px $gray-200;
    transform: translateY(-2px);
  }
  &:hover .view > img {
    transform: scale(1.1);
  }
}

.content {
  width: 80%;
  margin-right: 40px;

  .title {
    margin-top: 8px;
  }

  .desc {
    margin-top: 8px;

    color: $gray-700;
  }

  @include below(small) {
    width: 100%;
    margin-right: 0;
  }
}

.view {
  display: block;
  width: 20%;
  min-width: 256px;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    transition: all 0.3s ease-in-out;
  }

  @include below(small) {
    display: none;
  }
}

.newsInfos {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.newsLogo {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  border-radius: 16px;
  object-fit: cover;
}

.newsName {
  color: $bluko-500;
}

.date {
  margin-left: 4px;

  color: $gray-500;
}
</style>
